import { Component, Input, Output, EventEmitter, OnChanges, ChangeDetectorRef, ViewChild } from '@angular/core';
import { JustTime } from 'src/app/helpers/helpers';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { CommonModule } from '@angular/common';
@Component({
    selector: 'joi-hm-input',
    template: `
<div class="hm-holder">
  <joi-input
    [ngClass]="{ singleHours: !hoursFocused && (!numberHours || numberHours < 10) }"
    (focused)="focusNumberHours(true)"
    (unfocusInput)="focusNumberHours(false)"
    [(model)]="hours"
    (joiChange)="getTime()"
    [autoSelect]="true"
    [placeholder]="'0'"
    [disabled]="readOnly"
    [maxlength]="3"
    [allowableCharacters]="'0123456789'"
  ></joi-input>
  :
  <joi-input
    #minutesInput
    [(model)]="minutes"
    (joiChange)="getTime()"
    [autoSelect]="true"
    [placeholder]="'00'"
    [disabled]="readOnly"
    [maxlength]="2"
    [allowableCharacters]="'0123456789'"
  ></joi-input>
  <ng-container *ngIf="!!showSeconds">
    :
    <joi-input
      #secondsInput
      [(model)]="seconds"
      (joiChange)="getTime()"
      [autoSelect]="true"
      [placeholder]="'00'"
      [disabled]="readOnly"
      [maxlength]="2"
      [allowableCharacters]="'0123456789'"
    ></joi-input>
  </ng-container>
</div>
`,
    styles: [`
.hm-holder { display: flex; align-items: center; }
joi-input.singleHours { display: block; max-width: 14px; }
  `],
    standalone: true,
    imports: [JoiInputComponent, CommonModule]
})
export class JoiHMInputComponent implements OnChanges {
  @Input() minMinutes = 1
  @Input() maxMinutes: number = null
  @Input() maxHours: number = null
  @Input() minSeconds = 0
  @Input() maxSeconds: number = 59
  @Input() startingMinutes: number
  @Input() startingJustTime: JustTime
  @Input() allowNoValue = false
  @Input() showSeconds = false
  @Input() readOnly = false

  minutes: string
  hours: string
  seconds: string
  hoursFocused = false
  numberHours: number // ironically this is used purely to help determine the width of the hours input
  @Output() timeChange: EventEmitter<HMTimes> = new EventEmitter()
  @ViewChild('minutesInput') minutesInput: JoiInputComponent
  @ViewChild('secondsInput') secondsInput: JoiInputComponent

  focusNumberHours(focus) {
    this.hoursFocused = focus
  }

  ngOnChanges(changes) {
    const { startingMinutes, startingJustTime } = changes
    const minutes = startingMinutes ? startingMinutes.currentValue : null
    const justTime = startingJustTime ? startingJustTime.currentValue : null
    if (minutes || minutes === 0) this.setHHMM(Math.floor(minutes/60), minutes%60, 0)
    if (justTime) this.setHHMM(justTime.h, justTime.m, justTime.s || 0)
  }

  setHHMM(hours: number, minutes: number, seconds: number) {
    this.minutes = !minutes && minutes !== 0 ? null : `${ minutes > 9 ? minutes : '0' + minutes }`
    this.seconds = !seconds && seconds !== 0 ? null : `${ seconds > 9 ? seconds : '0' + seconds }`
    this.hours = hours.toString()
    // console.log({ hours, seconds, minutes, thisseconds: this.seconds })

    this.numberHours = hours
  }

  getHHMM(hours: number, minutes: number) {
    return `${hours}:${ minutes > 9 ? minutes : '0' + minutes }`
  }
  

  getTime() {
    let hours: any = this.hours
    let minutes: any = this.minutes
    let seconds: any = this.seconds

    if (!hours  && !minutes && (!this.showSeconds || !seconds) && this.allowNoValue) {
      this.timeChange.emit(null)
      return
    }
    hours = hours ? parseInt(hours) : 0
    minutes = minutes ? parseInt(minutes) : 0
    minutes = Math.min(59, minutes)
    seconds = seconds ? parseInt(seconds) : 0
    seconds = Math.min(59, seconds)

    if (seconds < 0) seconds = 0
    if (minutes < 0) minutes = 0
    if (hours < 0) hours = 0

    if (!hours && minutes < this.minMinutes) minutes = this.minMinutes
    if (minutes && !!this.maxMinutes && minutes > this.maxMinutes) minutes = this.maxMinutes
    if (this.maxHours && hours > this.maxHours) hours = this.maxHours
    if (seconds && !!this.maxSeconds && seconds > this.maxSeconds) seconds = this.maxSeconds

    if (!hours) hours = 0
    if (!minutes) minutes = 0
    if (!seconds) seconds = 0

    const timeText = this.getHHMM(hours, minutes)
    const justTime: JustTime = { h: hours, m: minutes }
    if (this.showSeconds) justTime.s = seconds

    this.timeChange.emit({ justTime, timeText, minutes: hours * 60 + minutes })
    this.setHHMM(hours, minutes, seconds)
    setTimeout(() => {
      if(this.minutesInput?.setModel) this.minutesInput.setModel(this.minutes)
      if(this.secondsInput?.setModel) this.secondsInput.setModel(this.seconds)
    })
  }

}

export interface HMTimes {
  justTime: JustTime,
  timeText: string,
  minutes: number
}